import { Menu, MenuItem } from "@mui/material";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import { useState } from "react";
import { FONT_FAMILY } from "../../theme";
import { FilterAndSortButton } from "../TracksPageComponents/styles";
import { sortMenuStyles } from "../TracksPageComponents/styles";
import { sortOptions } from "../ExploreBase/types";
import { ExploreSortMenuProps } from "./types";

export const ExploreSortMenu: React.FC<ExploreSortMenuProps> = ({
  handleSort,
}) => {
  const [sortAnchorEl, setSortAnchorEl] = useState<null | HTMLElement>(null);
  const openSortMenu = Boolean(sortAnchorEl);
  const handleOpenSortDropdown = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    setSortAnchorEl(event.currentTarget);
  };

  const handleSortDropdownClose = () => {
    setSortAnchorEl(null);
  };

  return (
    <>
      <FilterAndSortButton
        aria-controls={openSortMenu ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={openSortMenu ? "true" : undefined}
        onClick={handleOpenSortDropdown}
        sx={sortMenuStyles.button}
      >
        <SwapVertOutlinedIcon sx={{ margin: "5px" }} />
        Sort
      </FilterAndSortButton>
      <Menu
        id="basic-menu"
        anchorEl={sortAnchorEl}
        open={openSortMenu}
        onClose={handleSortDropdownClose}
        PaperProps={{
          style: sortMenuStyles.paperProps,
        }}
        sx={sortMenuStyles.menu}
      >
        {sortOptions.map((value) => (
          <MenuItem
            onClick={() => {
              handleSort(value);
              handleSortDropdownClose();
            }}
            key={value}
            value={value}
            sx={{ fontFamily: FONT_FAMILY }}
          >
            {value}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
